var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c(
      "span",
      {
        staticClass: "rating-label",
        class: "interview-" + _vm.label,
        attrs: { "data-test": "label-style" },
      },
      [
        _c("img", {
          attrs: { src: _vm.imageUrl + "/interview_" + _vm.label + ".png" },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "star-list" },
      [
        _vm._l(_vm.value, function (i) {
          return _c("li", { key: "star-" + i }, [
            _c("img", {
              staticClass: "blue-star",
              attrs: {
                "data-test": "test-stars",
                src: _vm.imageUrl + "/interview_star_img.png",
              },
            }),
          ])
        }),
        _vm._v(" "),
        _vm._l(5 - _vm.value, function (i) {
          return _c("li", { key: "blank-star-" + i }, [
            _c("img", {
              staticClass: "blue-star",
              attrs: {
                "data-test": "test-blank-stars",
                src: _vm.imageUrl + "/interview_star_none_img.png",
              },
            }),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }